import React from 'react';
import PropTypes from 'prop-types';

const propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};

const FavoritesIcon = ({ color = '#fff', size = 20, ...props }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 32 34"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M31.306 14.502c.63-.64.852-1.581.58-2.455-.272-.874-.982-1.498-1.853-1.63L22.285 9.24a1.016 1.016 0 0 1-.763-.579l-3.464-7.327C17.67.512 16.88 0 16 0c-.879 0-1.668.512-2.057 1.335l-3.465 7.328a1.017 1.017 0 0 1-.763.579l-7.748 1.175c-.87.132-1.58.756-1.853 1.63a2.453 2.453 0 0 0 .58 2.456L6.3 20.206c.24.244.349.594.293.936L5.27 29.196c-.117.71.061 1.399.5 1.943.684.847 1.876 1.105 2.83.582l6.929-3.803a.999.999 0 0 1 .943 0l6.93 3.803c.337.185.696.279 1.067.279.678 0 1.32-.314 1.761-.861.44-.544.618-1.235.5-1.943l-1.323-8.054a1.087 1.087 0 0 1 .293-.936l5.606-5.704z"
      fill={color}
    />
  </svg>
);

FavoritesIcon.propTypes = propTypes;

export default FavoritesIcon;
